import Profile from "../../views/Player/Profile.vue";
import Lessons from "../../views/Player/Lessons.vue";
import BookLesson from "../../components/Shared/Book-Lesson.vue";
import BookVideoLesson from "../../components/Shared/Book-Video-Lesson.vue";
import BookLessonChooseType from "../../components/Shared/Book-Lesson-choose-type.vue";
import ChangeLesson from "../../components/Shared/Change-Lesson.vue";
import Lesson from "../../views/Player/Lessons/Lesson.vue";
import PlayerBag from "../../views/Player/Profile/Bag.vue";
import Skills from "../../views/Player/Profile/Skills.vue";
import BookLessonConfirmation from "../../components/Shared/Book-Lesson-confirmation.vue";

export default [
    {
        path: "/player",
        name: "Player",
        redirect: { name: "playerProfile" },
        component: () => import("../../views/Player.vue"),
        children: [
            {
                path: "profile",
                name: "playerProfile",
                meta: {
                    isAuth: true,
                },
                component: Profile,
            },
            {
                path: "pro-profile",
                name: "playerProProfile",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Player/PlayerProProfile.vue"),
            },
            {
                path: "pro-bag/:id",
                name: "playerProBag",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Player/playerProBag.vue"),
            },
            {
                path: "yardages",
                name: "playerYardages",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Player/Profile/Yardages.vue"),
            },
            {
                path: "lessons",
                name: "playerLessons",
                component: Lessons,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "lessons/book",
                name: "BookLesson",
                component: BookLesson,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "lessons/bookvideo",
                name: "BookVideoLesson",
                component: BookVideoLesson,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "lessons/bookchoosetype",
                name: "BookChooseType",
                meta: {
                    isAuth: true,
                },
                component: BookLessonChooseType,
            },
            {
                path: "lessons/records",
                name: "playerLessonsHistory",
                component: () => import("../../views/Player/Profile/LessonsHistory.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "lessons/book/:id/confirmation",
                name: "BookLessonConfirmation",
                component: BookLessonConfirmation,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "lessons/change/:id",
                name: "LessonChange",
                meta: {
                    isAuth: true,
                },
                component: ChangeLesson,
            },
            {
                path: "lessons/credits",
                name: "AddCredits",
                component: () => import("../../views/Player/Lessons/Add-credits.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "lesson/:id",
                name: "playerLesson",
                component: Lesson,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "bag",
                name: "playerBag",
                component: PlayerBag,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "goals",
                name: "playerGoals",
                component: () => import("../../views/Player/Goals.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "skills",
                name: "playerSkills",
                component: Skills,
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "offers",
                name: "playerOffers",
                component: () => import("../../views/Player/Offers.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "offers/:id",
                name: "offer",
                component: () => import("../../views/Player/Offers/Offer.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "messages",
                name: "playerMessages",
                component: () => import("../../views/Player/Messages.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "messages/all",
                name: "playerMessagesAll",
                component: () => import("../../views/Player/Messages/All-messages.vue"),
                meta: {
                    isAuth: true,
                },
            },
            {
                path: "messages/:id",
                name: "playerMessage",
                component: () => import("../../views/Player/Messages/Message.vue"),
                meta: {
                    isAuth: true,
                },
            },
        ],
    },
];
